import styled from 'styled-components';
import { rem } from 'polished';
import variables from '@styles/variables';

export const StyledBar = styled.div`
  position: relative;
  width: 100%;
  height: ${rem(2)};
  background-color: ${variables.colors.mediumGray};
`;

export const StyledProgress = styled.div<{ $width: number }>`
  position: absolute;
  top: 0;
  left: 0;
  height: ${rem(2)};
  background-color: ${variables.colors.primary};
  width: ${(props) => props.$width}%;
`;
